export const checkboxes = [
  {
    name: "catagory_is_organization",
    title: "Is Organization",
  },
  {
    name: "catagory_is_member",
    title: "Is Member",
  },
  {
    name: "catagory_is_not_member",
    title: "Is not member",
  },
  {
    name: "allowedEasyCare",
    title: "Easycare",
  },
];
